//var db = process.env.VUE_APP_DATABASE_ENDPOINT
const firebaseConfig = {
  apiKey: "AIzaSyDpQX2opHg4XjVJYKKFKmWg6MTR_o5wmac",
  authDomain: "sps-broker.firebaseapp.com",
  databaseURL: "https://sps-broker-default-rtdb.firebaseio.com",
  projectId: "sps-broker",
  storageBucket: "sps-broker.appspot.com",
  messagingSenderId: "253480600616",
  appId: "1:253480600616:web:a757a47ecfecd0f3fee11d",
  measurementId: "G-PV2LY736KL"
}

export default firebaseConfig